export const AGENT_ID_PARAM_KEY = 'agentId';
export const PROPOSAL_ID_PARAM_KEY = 'proposalId';
export const PASSWORD_TOKEN_PARAM_KEY = 'passwordToken';
export const SESSION_ACCESS_TOKEN_PARAM_KEY = 'sessionAccessToken';
export const ID_DOCUMENT_TYPE_PARAM_KEY = 'idDocumentType';
export const CLIENT_ACCESS_POINT_PARAM_KEY = 'clientAccessPoint';
export const SALE_REPORT_ID_PARAM_KEY = 'saleReportId';
